import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audio-controller" }
const _hoisted_2 = { class: "audio-controller__time" }
const _hoisted_3 = { class: "audio-controller__duration" }

import {computed, onMounted, onUnmounted, ref, watch} from 'vue';
import AudioSlider from "@/components/UI/AudioPlayer/AudioSlider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AudioController',
  props: {
  audio: {
    type: Audio,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const currentTime = ref('00:00');
const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
const duration = ref(formatTime(props.audio!.duration))
const progress = ref(0);
const onChangedAudio = () => {
  props.audio!.addEventListener('loadedmetadata', () => {
    duration.value = formatTime(props.audio!.duration);
  });
  props.audio!.addEventListener('play', () => {
    duration.value = formatTime(props.audio!.duration);
  });
  props.audio!.addEventListener('timeupdate', updateTime);
};
watch(() => props.audio, onChangedAudio);
onMounted(() => {
  onChangedAudio();
});

onUnmounted(() => {
  props.audio!.removeEventListener('timeupdate', updateTime);
});

const updateTime = () => {
  currentTime.value = formatTime(props.audio!.currentTime);
  progress.value = (props.audio!.currentTime / props.audio!.duration) * 100;
};


const changeTime = (event) => {
  props.audio!.currentTime = (event.target.value / 100) * props.audio!.duration;
};
const wrapChangeTime = (value) => {
  props.audio!.currentTime = value * props.audio!.duration;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AudioSlider, {
        min: 0,
        max: 100,
        modelValue: progress.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((progress).value = $event)),
        onInput: changeTime,
        onWrapinput: wrapChangeTime
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(currentTime.value), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(duration.value), 1)
  ]))
}
}

})